import { render, staticRenderFns } from "./maestro-menu-layout.vue?vue&type=template&id=455b4a76&scoped=true&"
import script from "./maestro-menu-layout.vue?vue&type=script&lang=js&"
export * from "./maestro-menu-layout.vue?vue&type=script&lang=js&"
import style0 from "./maestro-menu-layout.vue?vue&type=style&index=0&id=455b4a76&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "455b4a76",
  null
  
)

export default component.exports